import { createCash } from '@/api/mutations/cash';
import { useState } from 'react';
import { addCash, setPending } from '../../redux/data/dataSlice';
import { CashType } from '../../redux/data/dataTypes';
import { useAppDispatch } from '../../redux/hooks';

export const useCashManage = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const submit = async (data: CashType) => {
    setIsLoading(true);
    return new Promise((resolve, reject) => {
      return createCash(data)
        .then(() => {
          dispatch(addCash(data));
          resolve(true);
        })
        .catch((err) => {
          if (!err.statusCode) {
            dispatch(
              setPending({
                type: 'ADD_CASH',
                ID: data.ID,
                data: JSON.stringify(data),
              })
            );
            dispatch(addCash(data));
          } else {
            return reject(err);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    });
  };

  return { submit, isLoading };
};
